/**
 * 地址缓存标
 */
export const ADDRESS_CACHE_TAG_KEY = 'addressCacheTagForPC';

/**
 * 地址 Cookie
 */
// Default address cookie name
export const ADDRESS_KEY = 'USER_ADDRESS_AREA_KEY';
// Default cascade (postCode info) address cookie name
export const AREA = 'CASCADE_ADDRESS_AREA_KEY';
// Default cookie timeout: Unit: days
export const EXPIRE_DAYS = 30;

/**
 * 国家/地址引导弹窗
 */
export const COUNTRY_ALERT_DISMISSED = 'countryAlertDismissed';
export const ADDRESS_ALERT_DISMISSED = 'addressAlertDismissed';

export enum PAGE_TYPE {
  PERSON = 'person',
  SHIPPING = 'shipping',
  BILLING = 'billing',
  PAY_BILLING = 'pay_billing', // 收银台（信用卡支付）
  ADDRESS_LIB = 'address_lib', // 地址组件
}

export enum PICK_MODIFY_TYPE {
  SAVE = 1, // 收藏
  UN_SAVE = 2, // 取消收藏
  DEFAULT = 3, // 设置默认
  UD_DEFAULT = 4, // 取消设置默认
}

export enum ADDRESS_VERIFY_TYPE {
  NO_VERIFY = 0, // 不校验
  COUNTRY_VERIFY = 1, // 按国家维度校验
  SITE_VERIFY = 2, // 按站点维度校验
}

/**
 * 各国家默认地址配置
 */
export const DEFAULT_COUNTRY_ADDRESSES: Record<
  string,
  {
    provinceId: number;
    cityId: number;
    districtId: number;
    townId: number;
    postCode: string;
  }
> = {
  // 英国
  GB: {
    provinceId: 30000004,
    cityId: 30000005,
    districtId: 30000006,
    townId: 30000007,
    postCode: 'SW1A 1AA',
  },
  // 荷兰
  NL: {
    provinceId: 50000000,
    cityId: 50000140,
    districtId: 50004838,
    townId: 50048789,
    postCode: '1071CJ',
  },
  // 比利时
  BE: {
    provinceId: 100000000,
    cityId: 100000080,
    districtId: 100000657,
    townId: 0,
    postCode: '1000',
  },
  // 卢森堡
  LU: {
    provinceId: 110000508,
    cityId: 110000624,
    districtId: 110000660,
    townId: 0,
    postCode: '2345',
  },
  // 法国
  FR: {
    provinceId: 40000074,
    cityId: 40004343,
    districtId: 40010310,
    townId: 0,
    postCode: '75007',
  },
  // 德国
  DE: {
    provinceId: 60000001,
    cityId: 60000018,
    districtId: 60000915,
    townId: 0,
    postCode: '10117',
  },
  // 意大利
  IT: {
    provinceId: 132446,
    cityId: 141901,
    districtId: 0,
    townId: 0,
    postCode: '50122',
  },
  // 西班牙
  ES: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '28014',
  },
  // 葡萄牙
  PT: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '1349-021',
  },
  // 希腊
  GR: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '10674',
  },
  // 爱尔兰
  IE: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: 'D02 K303',
  },
  // 保加利亚
  BG: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '1000',
  },
  // 奥地利
  AT: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '1010',
  },
  // 罗马尼亚
  RO: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '010063',
  },
  // 波兰
  PL: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '00-495',
  },
  // 匈牙利
  HU: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '1014',
  },
  // 丹麦
  DK: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '1307',
  },
  // 芬兰
  FI: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '00100',
  },
  // 斯洛文尼亚
  SI: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '1000',
  },
  // 瑞典
  SE: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '11186',
  },
  // 爱沙尼亚
  EE: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '10127',
  },
  // 立陶宛
  LT: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '01124',
  },
  // 拉脱维亚
  LV: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: 'LV-1050',
  },
  // 捷克
  CZ: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '110 00',
  },
  // 克罗地亚
  HR: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '10000',
  },
  // 瑞士
  CH: {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '8001',
  },
};

/**
 * 国家权限白名单 - 无国家访问权限时允许访问的页面
 */
export const COUNTRY_ACCESS_WHITE_LIST = [
  '/login',
  '/jd-auth-redirect',
  '/ochama-auth-redirect',
  '/apple-auth-redirect',
  '/google-auth-redirect',
  '/facebook-auth-redirect',
  '/notAllowed',
];
